import AccountCircleOutlinedIcon from "@mui/icons-material/AccountCircleOutlined";
import LockOpenOutlinedIcon from "@mui/icons-material/LockOpenOutlined";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import type { MenuListItem } from "@naf/teamscheme";
import type { Dispatch, SetStateAction } from "react";
import { useCustomer } from "../../../auth/CustomerContext";
import { loginWithRedirect, logout } from "../../../auth/auth0Client";
import BECOME_MEMBER_URL from "../../../membership/BecomeMemberNafnoExternalUrl";
import MITT_NAF_URL from "../../../membership/MittNafExternalUrl";
import { EVENTS, externalLinkEvent } from "../../Tracking";

function createBecomeMemberProps(): MenuListItem {
  const props: MenuListItem = {
    key: "BliMedlem",
    text: "Bli medlem",
    href: BECOME_MEMBER_URL,
    trackEvent: externalLinkEvent(BECOME_MEMBER_URL),
  };
  return props;
}

function createLoggedInHeaderProps(): MenuListItem {
  const props: MenuListItem = {
    key: "MittNAF",
    text: "Mitt NAF",
    icon: {
      icon: <AccountCircleOutlinedIcon className="icon" />,
    },
    href: MITT_NAF_URL,
    trackEvent: externalLinkEvent(MITT_NAF_URL),
  };
  return props;
}

function createLoginHeaderProps(): MenuListItem {
  const props: MenuListItem = {
    key: "LoggInn",
    text: "Logg inn",
    icon: {
      icon: <LockOutlinedIcon className="icon hide" />,
      hoverIcon: <LockOpenOutlinedIcon className="hoverIcon hide" />,
    },
    trackEvent: EVENTS.HEADER.LOG_IN,
    onClick: () => {
      loginWithRedirect({
        targetUrl: `${window.location.pathname}${window.location.search}`,
      });
    },
  };
  return props;
}

function createLogoutHeaderProps(): MenuListItem {
  const props: MenuListItem = {
    key: "LoggUt",
    text: "Logg ut",
    trackEvent: EVENTS.HEADER.LOG_OUT,
    onClick: () => logout(),
  };
  return props;
}

export function useAuthHeaderElements() {
  const customer = useCustomer();
  if (customer.isLoading) {
    const loading: MenuListItem = {
      key: "HenterBruker",
      text: "Henter bruker",
      isLoading: true,
    };
    return [loading];
  }
  if (customer.result && customer.isLoggedIn) {
    const loggedIn = createLoggedInHeaderProps();
    const logout = createLogoutHeaderProps();
    if (!customer.result.hasMembership) {
      return [loggedIn, logout, createBecomeMemberProps()];
    }
    return [loggedIn, logout];
  }
  return [createLoginHeaderProps(), createBecomeMemberProps()];
}

export function createFaqHeaderProps(
  isOpen: boolean,
  setOpen: Dispatch<SetStateAction<boolean>>,
): MenuListItem {
  const props: MenuListItem = {
    key: "FAQ",
    text: "Vanlige spørsmål",
    onClick: () => setOpen(!isOpen),
    trackEvent: EVENTS.HEADER.FAQ,
  };
  return props;
}
